module.exports = __webpack_public_path__ + "static/media/dazzle-slash.fa73cc32.png";